import {
	SET_FREQUENCY_SETTINGS_IDS,
	FETCH_CONFIGURED_LIMITS,
	RESET_CONFIGURED_LIMITS,
	RESET_FREQUENCY_SETTINGS_IDS,
	SHOW_DELETE_LIMIT_DIALOG,
	HIDE_DELETE_LIMIT_DIALOG,
	SHOW_UPDATE_LIMIT_DIALOG,
	HIDE_UPDATE_LIMIT_DIALOG
} from "./ConfiguredLimitsActionsTypes";
import ConfiguredLimitsFactory from "../../factories/ConfiguredLimitsFactory";
import { RESET_STATE } from "@/stores/CommumActionTypes";

const mutations = {
	[SET_FREQUENCY_SETTINGS_IDS]: (state, ids) =>
	{
		state.frequencySettingsIds = ids;
	},
	[RESET_FREQUENCY_SETTINGS_IDS]: (state) =>
	{
		state.frequencySettingsIds = [];
	},
	[FETCH_CONFIGURED_LIMITS]: (state, tableData) =>
	{
		state.tableData = tableData;
	},
	[RESET_CONFIGURED_LIMITS]: (state) =>
	{
		state.tableData = [];
	},
	[SHOW_DELETE_LIMIT_DIALOG]: (state) =>
	{
		state.showDeleteLimitDialog = true;
	},
	[HIDE_DELETE_LIMIT_DIALOG]: (state) =>
	{
		state.showDeleteLimitDialog = false;
	},
	[SHOW_UPDATE_LIMIT_DIALOG]: (state) =>
	{
		state.showUpdateLimitDialog = true;
	},
	[HIDE_UPDATE_LIMIT_DIALOG]: (state) =>
	{
		state.showUpdateLimitDialog = false;
	},
	[RESET_STATE]: (state) =>
	{
		Object.assign(state, ConfiguredLimitsFactory.EmptyState());
	},
};

export default { mutations };